import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import { useHtzPositionCatalogShowQuery } from "@/services/backend/htz/position-catalog/api/position-catalog-api";
import { NavLink, useParams } from "react-router";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { CompanyName } from "@/services/backend/company/components/company-name";
import { ArrowLeft, RefreshCw } from "lucide-react";
import t from "@/lang/lang";
import { PositionCatalogItemTable } from "@/services/backend/htz/position-catalog/components/position-catalog-item-table";
import { PutPositionCatalogItemDialog } from "@/services/backend/htz/position-catalog/components/put-position-catalog-item-dialog";
import { Button } from "@/shared/components/ui/button";

export function PositionCatalogRoute() {
  const { positionCatalogId } = useParams();

  const {
    data: catalog,
    isLoading,
    error,
  } = useHtzPositionCatalogShowQuery({
    id: positionCatalogId!,
  });

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (isLoading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="flex space-x-4">
            <RefreshCw className="animate-spin" />
            <span>{t("Lade Katalog")}</span>
          </CardTitle>
        </CardHeader>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>
          <NavLink to="./..">
            <Button variant="outline" size="sm" className="m-0 mb-4">
              <ArrowLeft className="mr-2 h-4 w-4" />
              <span>{t("Übersicht")}</span>
            </Button>
          </NavLink>
          <div>{catalog!.name}</div>
        </CardTitle>
        <CardDescription>
          <CompanyName companyId={catalog!.companyId} />
        </CardDescription>
        <CardAction>
          <PutPositionCatalogItemDialog catalogId={catalog!.id} />
        </CardAction>
      </CardHeader>
      <CardContent>
        <PositionCatalogItemTable catalog={catalog!} />
      </CardContent>
    </Card>
  );
}
